export default __webpack_public_path__ + "static/media/custom_token.62889ea8.png";